export var AppStates;
(function (AppStates) {
    AppStates["Meter"] = "meter";
    AppStates["Promises"] = "promises";
    AppStates["IntegrateFlittz"] = "integrateFlittz";
    AppStates["ConversationPromiseTimeout"] = "conversationPromiseTimeout";
    AppStates["ActionPromiseTimeout"] = "actionPromiseTimeout";
    AppStates["DynamicMeterPromiseTimeout"] = "dnamicMeterPromiseTimeout";
    AppStates["Debug"] = "debug";
    AppStates["IsInitFinished"] = "isInitFinished";
    AppStates["SiteCode"] = "siteCode";
    AppStates["ConfigCode"] = "configCode";
    AppStates["PluginStartTime"] = "pluginStartTime";
    AppStates["ActionStartTime"] = "actionStartTime";
    AppStates["ActionEndTime"] = "actionEndTime";
    AppStates["RunTimeout"] = "runTimeout";
    AppStates["ApiUrl"] = "apiUrl";
    AppStates["DeviceId"] = "deviceId";
    AppStates["IsChangedDeviceId"] = "isChangedDeviceId";
    AppStates["FirstRunExecuted"] = "FIRST_RUN_EXECUTED";
    AppStates["ProductCode"] = "productCode";
    AppStates["Silentmode"] = "silentmode";
    AppStates["BatchCount"] = "batchCount";
    AppStates["SettingsKey"] = "settingsKey";
    AppStates["ClientCode"] = "clientCode";
    AppStates["AuthSettings"] = "authSettings";
    AppStates["UseRootDomain"] = "useRootDomain";
    AppStates["IsProcessed"] = "isProcessed";
    AppStates["StartProcessingTime"] = "startProcessingTime";
    AppStates["AppInsightsKey"] = "appInsightsKey";
    AppStates["ViewsUpdateFromServerPeriod"] = "ViewsUpdateFromServerPeriod";
    AppStates["ArticlesCounter"] = "articlesCounter";
    AppStates["AppOptions"] = "AppOptions";
    AppStates["Attr"] = "attr";
    AppStates["PaperCode"] = "paperCode";
    AppStates["Environment"] = "environment";
    AppStates["UserAuthenticationTime"] = "userAuthenticationTime";
    AppStates["UserIgmAuthTime"] = "userIgmAuthTime";
    AppStates["CurrentConversation"] = "currentConversation";
    AppStates["NeedHideWhitelistInfobox"] = "needHideWhitelistInfobox";
    AppStates["ActivationInstance"] = "activationInstance";
    AppStates["CampaignInstance"] = "campaignInstance";
    AppStates["ActionModuleInstance"] = "actionModuleInstance";
    AppStates["Application"] = "application";
    AppStates["RunReason"] = "runReason";
    AppStates["DebugInstance"] = "debugInstance";
    AppStates["LastIpDeniedReason"] = "lastIpDeniedReason";
    AppStates["UseStorageSecurity"] = "useStorageSecurity";
    AppStates["SwGInstance"] = "swgInstance";
    AppStates["ArticleIdProvider"] = "articleIdProvider";
    AppStates["G2IUserData"] = "G2IUserData";
    AppStates["OldNewDeviceId"] = "oldNewDeviceId";
    AppStates["ForceAuthSystemLogout"] = "forceAuthSystemLogout";
    AppStates["RefreshUserdataEveryPageload"] = "refreshUserdataEveryPageload";
    AppStates["UserStatePerPageload"] = "userStatePerPageload";
    AppStates["cdpEnabled"] = "cdpEnabled";
    AppStates["NewsLetterActionName"] = "newsLetterActionName";
    AppStates["Auth0UserProfile"] = "auth0UserProfile";
    AppStates["DisablePaywall"] = "disablePaywall";
    AppStates["Auth0DB_approach"] = "Auth0DB_approach";
})(AppStates || (AppStates = {}));
;
